module.exports = __webpack_public_path__ + "static/media/assessmentsBanner.d053135c.svg";